import type { RendererProps } from "@circle-react-uikit/ImageInput/ImageSelector";
import { ImageLoader } from "./ImageLoader";
import { ImagePreview } from "./ImagePreview";
import { UploadButtons } from "./UploadButtons";

export const ImageUploadBlock = ({
  value,
  processing,
  imageUrl,
  handleChangeCoverClick,
  handleDelete,
}: RendererProps) =>
  processing ? (
    <ImageLoader />
  ) : value && imageUrl ? (
    <ImagePreview
      imageUrl={imageUrl}
      handleChangeCoverClick={handleChangeCoverClick}
      handleDelete={handleDelete}
    />
  ) : (
    <UploadButtons handleChangeCoverClick={handleChangeCoverClick} />
  );
